import React from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import s from '../styles.module.scss'

import FooterLogin from '../footer-login/footer-login'
import { LoginInterface } from '../login.types'
import { InputText } from '../../../../components/molecules/input-text'
import { formatError, formatGqlError } from '../../../../utils/format-error'
import regex from '../../../../utils/regex'

export interface InputsLogin {
  email: string
  password: string
}

interface LoginForm extends LoginInterface {
  setShowForgotPassword: React.Dispatch<React.SetStateAction<boolean>>
}

const LoginForm = ({
  title,
  onLogin,
  isLoading,
  setShowForgotPassword,
  footerElement,
}: LoginForm) => {
  const { control, handleSubmit, setError } = useForm<InputsLogin>({
    defaultValues: {
      email: '',
      password: '',
    },
  })

  const onSubmit: SubmitHandler<InputsLogin> = async ({ email, password }) => {
    try {
      await onLogin({ email, password })
    } catch (e) {
      const gqlError = formatGqlError(e)
      const defaultError = formatError(e)

      const errorMessage = gqlError?.message || defaultError?.message

      if (errorMessage.includes('ERROR_WITH_CREDENTIALS')) {
        setError('password', {
          type: 'string',
          message: 'Vérifiez votre mot de passe',
        })
      } else if (errorMessage.includes('EMAIL_NOT_FOUND')) {
        setError('email', {
          type: 'string',
          message: 'Vérifiez votre adresse e-mail',
        })
      } else if (
        errorMessage.includes('ACCOUNT_NOT_VALIDATED') ||
        errorMessage.includes('NO_PASSWORD_FOUND')
      ) {
        setError('password', {
          type: 'string',
          message:
            "Votre compte n'est pas encore activé. Contactez votre référent.",
        })
      } else {
        setError('password', {
          type: 'string',
          message:
            'Une erreur est survenue. Veuillez réessayer ultérieurement.',
        })
        setError('email', {
          type: 'string',
          message:
            'Une erreur est survenue. Veuillez réessayer ultérieurement.',
        })
      }
    }
  }

  return (
    <form className={s.form}>
      <h2 className={s.title}>{title}</h2>
      <InputText
        control={control}
        name='email'
        label='Adresse e-mail'
        rules={{
          required: 'Une adresse e-mail est requise.',
          pattern: {
            value: regex.email,
            message: "Respecter le bon format d'e-mail",
          },
        }}
        inputProps={{
          type: 'text',
          'aria-label': 'entrez votre e-mail',
          'aria-required': 'true',
        }}
        placeholder='Entrez votre e-mail'
        dataTestId='email-input'
      />

      <>
        <InputText
          control={control}
          name='password'
          label='Mot de passe'
          rules={{
            required: 'Un mot de passe est requis.',
          }}
          inputProps={{
            type: 'password',
            'aria-label': 'entrez votre mot de passe',
            'aria-required': 'true',
          }}
          placeholder='Entrez votre mot de passe'
          dataTestId='password-input'
        />

        <div className={s.forgetPassword}>
          <span
            className={s.underline}
            onClick={() => setShowForgotPassword(true)}
            id='forgot-password'
            data-testid='forgot-password-button'
          >
            Mot de passe oublié
          </span>
        </div>
      </>

      <FooterLogin
        footerElement={footerElement}
        submit={{
          isLoading,
          onSubmit: handleSubmit(onSubmit),
          label: 'Se connecter',
          isValid: true,
        }}
      />
    </form>
  )
}

export default LoginForm
